<ng-container *ngIf="dynamicFormGroup">
  <form [formGroup]="dynamicFormGroup" id="DynamicDataForm" class="form-wrapper">
    <ng-container *ngFor="let customerFieldConfig of customerFieldsConfig">
      <ng-container [ngSwitch]="customerFieldConfig.fieldType">
        <!-- TEXT FIELDS -->
        <ng-container *ngSwitchCase="inputDataType.text">
          <ng-container [ngSwitch]="customerFieldConfig.fieldName">
            <!-- PREFIX DROPDOWN -->
            <ya-customselectinput *ngSwitchCase="'prefix'" formControlName="prefix" formTouchedOnClick
              [inputDataList]="prefixList" [inputPlaceholder]="getInputFieldPlaceholder(customerFieldConfig)"
              (optionSelected)="onPrefixSelected()">
            </ya-customselectinput>
            <!-- DEFAULT (TEXT + EMAIL) -->
            <div *ngSwitchDefault class="ya-input-container">
              <div class="ya-input-box">
                <input a11y_Input class="ya-input-text"
                  [type]="customerFieldConfig.fieldName === 'email' ? 'email' : 'text'"
                  [name]="customerFieldConfig.fieldName" [formControlName]="customerFieldConfig.fieldName"
                  [maxLength]="getMaxLength(customerFieldConfig.fieldName)" placeholder=" "
                  (focus)="onInputFocus(customerFieldConfig.fieldName)"
                  (blur)="onInputBlur(customerFieldConfig.fieldName); setWebView()"
                  (keyup)="customerFieldConfig.fieldName !== 'email' ? handleEnterKey($event) : null" />
                <div class="field_label">
                  <span>{{ getInputFieldPlaceholderString(customerFieldConfig) }}</span>
                </div>
              </div>
              <ng-container
                *ngIf="dynamicFormGroup.get(customerFieldConfig.fieldName) && dynamicFormGroup.get(customerFieldConfig.fieldName).touched && dynamicFormGroup.get(customerFieldConfig.fieldName).invalid">
                <ng-container
                  *ngIf="dynamicFormGroup.get(customerFieldConfig.fieldName).errors && getActiveErrorLabel(customerFieldConfig.fieldName)">
                  <span class="error-label">{{ getActiveErrorLabel(customerFieldConfig.fieldName) }}</span>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
        <!-- DATE FIELD -->
        <ng-container *ngSwitchCase="inputDataType.date">
          <ya-customcalendar [formControlName]="customerFieldConfig.fieldName" formTouchedOnClick class="dateInput"
            (dateNotValid)="isDateValid=$event; setCalendarValidation($event)"
            [calenderIsRequired]="customerFieldConfig.fieldName === 'bday_ymd' && customerFieldConfig.isRequired"
            label="DD.MM.YYYY">
            <ng-container *ngIf="dynamicFormGroup.get(customerFieldConfig.fieldName)">
              <ng-container
                *ngIf="(dynamicFormGroup.get(customerFieldConfig.fieldName).invalid && dynamicFormGroup.get(customerFieldConfig.fieldName).touched)">
                <span class="error-label">{{ getActiveErrorLabel(customerFieldConfig.fieldName) }}</span>
              </ng-container>
            </ng-container>
          </ya-customcalendar>
        </ng-container>
      </ng-container>
    </ng-container>
  </form>
</ng-container>